export const COLORS = {
    '#A71873': 'Pink',
    '#AA2429': 'Red',
    '#943E00': 'Orange',
    '#775940': 'Brown',
    '#2F6E3B': 'Grass',
    '#006D5B': 'Mint',
    '#00647D': 'Sky',
    '#0954A5': 'Blue',
    '#7938B2': 'Purple',
    '#3E3E3E': 'Gray',
};
